function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
const trapFocusHandlers = {};

function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        r = i[0],
        s = i[i.length - 1];
    removeTrapFocus(), trapFocusHandlers.focusin = t => {
        (t.target === e || t.target === s || t.target === r) && document.addEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.focusout = function() {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.keydown = function(t) {
        "TAB" === t.code.toUpperCase() && (t.target !== s || t.shiftKey || (t.preventDefault(), r.focus()), (t.target === e || t.target === r) && t.shiftKey && (t.preventDefault(), s.focus()))
    }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), t.focus()
}
try {
    document.querySelector(":focus-visible")
} catch {
    focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
    let e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        t = null,
        i = null;
    window.addEventListener("keydown", t => {
        e.includes(t.code.toUpperCase()) && (i = !1)
    }), window.addEventListener("mousedown", e => {
        i = !0
    }), window.addEventListener("focus", () => {
        t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused")
    }, !0)
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach(e => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
    }), document.querySelectorAll(".js-vimeo").forEach(e => {
        e.contentWindow.postMessage('{"method":"pause"}', "*")
    }), document.querySelectorAll("video").forEach(e => e.pause()), document.querySelectorAll("product-model").forEach(e => {
        e.modelViewerUI && e.modelViewerUI.pause()
    })
}

function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus()
}

function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    if (!t) return;
    let i = t.querySelector("summary");
    t.removeAttribute("open"), i.focus()
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
            bubbles: !0
        }), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
    }
}
customElements.define("quantity-input", QuantityInput);
class CartNote extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", debounce(e => {
            let t = JSON.stringify({
                note: e.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                body: t
            })
        }, 300))
    }
}

function debounce(e, t) {
    let i;
    return (...r) => {
        clearTimeout(i), i = setTimeout(() => e.apply(this, r), t)
    }
}
customElements.define("cart-note", CartNote);
const serializeForm = e => {
    let t = {},
        i = new FormData(e);
    for (let r of i.keys()) {
        let s = /(?:^(properties\[))(.*?)(?:\]$)/;
        s.test(r) ? (t.properties = t.properties || {}, t.properties[s.exec(r)[2]] = i.get(r)) : t[r] = i.get(r)
    }
    return JSON.stringify(t)
};

function fetchConfig(e = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${e}`
        }
    }
}
void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(e, t) {
    return function() {
        return e.apply(t, arguments)
    }
}, Shopify.setSelectorByValue = function(e, t) {
    for (var i = 0, r = e.options.length; i < r; i++) {
        var s = e.options[i];
        if (t == s.value || t == s.innerHTML) return e.selectedIndex = i, i
    }
}, Shopify.addListener = function(e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i)
}, Shopify.postLink = function(e, t) {
    var i = (t = t || {}).method || "post",
        r = t.parameters || {},
        s = document.createElement("form");
    for (var n in s.setAttribute("method", i), s.setAttribute("action", e), r) {
        var a = document.createElement("input");
        a.setAttribute("type", "hidden"), a.setAttribute("name", n), a.setAttribute("value", r[n]), s.appendChild(a)
    }
    document.body.appendChild(s), s.submit(), document.body.removeChild(s)
}, Shopify.CountryProvinceSelector = function(e, t, i) {
    this.countryEl = document.getElementById(e), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(i.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var e = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
    },
    initProvince: function() {
        var e = this.provinceEl.getAttribute("data-default");
        e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e)
    },
    countryHandler: function(e) {
        var t = this.countryEl.options[this.countryEl.selectedIndex],
            i = JSON.parse(t.getAttribute("data-provinces"));
        if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
        else {
            for (var r = 0; r < i.length; r++) {
                var t = document.createElement("option");
                t.value = i[r][0], t.innerHTML = i[r][1], this.provinceEl.appendChild(t)
            }
            this.provinceContainer.style.display = ""
        }
    },
    clearOptions: function(e) {
        for (; e.firstChild;) e.removeChild(e.firstChild)
    },
    setOptions: function(e, t) {
        for (var i = 0; i < t.length; i++) {
            var r = document.createElement("option");
            r.value = t[i], r.innerHTML = t[i], e.appendChild(r)
        }
        t.length
    }
};
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details");
        let e = this.querySelectorAll("summary");
        this.addAccessibilityAttributes(e), "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach(e => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onCloseButtonClick.bind(this)))
    }
    addAccessibilityAttributes(e) {
        e.forEach(e => {
            e.setAttribute("role", "button"), e.setAttribute("aria-expanded", !1), e.setAttribute("aria-controls", e.nextElementSibling.id)
        })
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        let t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t))
    }
    onSummaryClick(e) {
        let t = e.currentTarget,
            i = t.parentNode,
            r = i.hasAttribute("open");
        i === this.mainDetailsToggle ? (r && e.preventDefault(), r ? this.closeMenuDrawer(t) : this.openMenuDrawer(t)) : (trapFocus(t.nextElementSibling, i.querySelector("button")), setTimeout(() => {
            i.classList.add("menu-opening")
        }))
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), this.mainDetailsToggle.querySelectorAll("details").forEach(e => {
            e.setAttribute("open", "")
        }), e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(e => {
            e.classList.remove("menu-opening")
        }), this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(t), this.closeAnimation(this.mainDetailsToggle))
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        })
    }
    onCloseButtonClick(e) {
        let t = e.currentTarget.closest("details");
        this.closeSubmenu(t)
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(e)
    }
    closeAnimation(e) {
        let t, i = r => {
            void 0 === t && (t = r);
            let s = r - t;
            s < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")))
        };
        window.requestAnimationFrame(i)
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super()
    }
    openMenuDrawer(e) {
        this.header = this.header || document.getElementById("shopify-section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)), this.addEventListener("keyup", e => {
            "ESCAPE" === e.code.toUpperCase() && this.hide()
        }), this.classList.contains("media-modal") ? this.addEventListener("pointerup", e => {
            "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide()
        }) : this.addEventListener("click", e => {
            "MODAL-DIALOG" === e.target.nodeName && this.hide()
        })
    }
    show(e) {
        this.openedBy = e;
        let t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia()
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("button");
        if (!e) return;
        e.addEventListener("click", () => {
            let t = document.querySelector(this.getAttribute("data-modal"));
            t && t.show(e)
        })
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector('[id^="Deferred-Poster-"]');
        if (!e) return;
        e.addEventListener("click", this.loadContent.bind(this))
    }
    loadContent() {
        if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
            let e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), this.appendChild(e.querySelector("video, model-viewer, iframe")).focus()
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange), this.productState = {
            outofstock: !1,
            instock: !1
        }
    }
    onVariantChange() {
        this.updateOptions(), this.updateSelectedOptionLabels(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateStock(), this.updateStocks(), this.setProductState()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), e => e.value)
    }
    updateSelectedOptionLabels() {
        this.querySelectorAll("[data-selected-option-value]").forEach(e => {
            let t = Number(e.dataset.optionIndex);
            Number.isInteger(t) && this.options && null != this.options[t] && (e.textContent = this.options[t])
        })
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(e => !e.options.map((e, t) => this.options[t] === e).includes(!1))
    }
    updateMedia(e = 0) {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        let t = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!t) return;
        let i = t.parentElement;
        if (document.querySelector("body").classList.contains("product_sticky") && $(".product-single__media-wrapper").addClass("hide"), i.firstChild == t) return;
        i.prepend(t), document.querySelector("body").classList.contains("product_sticky") && t.classList.remove("hide");
        let r = document.querySelector(`[data-thumbnail-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!r) return;
        let s = r.parentElement;
        var n = s.getAttribute("data-slick-index");
        $(".product-single__thumbs").slick("slickGoTo", n), this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header"), this.stickyHeader && this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal")), window.setTimeout(() => {
            i.querySelector(".product-single__media-wrapper").scrollIntoView({
                behavior: "smooth"
            })
        })
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        let e = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        e.forEach(e => {
            let t = e.querySelector('input[name="id"]');
            t.value = this.currentVariant.id, t.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    updatePickupAvailability() {
        let e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), e.innerHTML = ""))
    }
    removeErrorMessage() {
        let e = this.closest("section");
        if (!e) return;
        let t = e.querySelector("product-form");
        t && t.handleErrorMessage()
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(e => e.text()).then(e => {
            let t = `price-${this.dataset.section}`,
                i = new DOMParser().parseFromString(e, "text/html"),
                r = document.getElementById(t),
                s = i.getElementById(t);
            s && r && (r.innerHTML = s.innerHTML);
            let n = document.getElementById(`price-${this.dataset.section}`);
            n && n.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
        })
    }
    toggleAddButton(e = !0, t, i = !0) {
        let r = document.getElementById(`product-form-${this.dataset.section}`);
        if (!r) return;
        let s = r.querySelector('[name="add"]'),
            n = r.querySelector('[name="add"] > span'),
            a = document.getElementById("product-qty"),
            o = document.getElementById("notify");
        if (s && (e ? (s.setAttribute("disabled", !0), t && (n.textContent = t), o.classList.remove("hide"), a.classList.add("hide")) : (s.removeAttribute("disabled"), n.textContent = window.variantStrings.addToCart, o.classList.add("hide"), a.classList.remove("hide")), !i)) return
    }
    setUnavailable() {
        let e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelector('[name="add"] > span'),
            r = document.getElementById(`price-${this.dataset.section}`),
            s = document.getElementById("product-qty"),
            n = document.getElementById("notify");
        t && (i.textContent = window.variantStrings.unavailable, n.classList.remove("hide"), s.classList.add("hide"), r && r.classList.add("visibility-hidden"))
    }
    setProductState() {
        this.productState.instock = this.currentVariant.available, this.productState.outofstock = !this.currentVariant.available
    }
    updateStock() {
        let e = this.currentVariant.id,
            t = document.querySelector("#pvr-" + e);
        if (!t) return;
        let i = t.getAttribute("data-id"),
            r = document.querySelector(".items"),
            s = document.querySelector(".product-inventory .inv");
        r && (r.textContent = i, this.currentVariant.available && (s.classList.add("instock"), s.classList.remove("outstock")), this.currentVariant.available || (s.classList.remove("instock"), s.classList.add("outstock")))
    }
    updateStocks() {
        let e = this.currentVariant.id,
            t = document.querySelector("#pvr-" + e);
        if (!t) return;
        let i = t.getAttribute("data-id"),
            r = document.querySelector(".quantity"),
            s = document.querySelector(".ttqtyprogress .QuantityAvailable");
        r && (r.textContent = i, this.currentVariant.available && (s.classList.add("instock"), s.classList.remove("outstock")), this.currentVariant.available || (s.classList.remove("instock"), s.classList.add("outstock")))
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super()
    }
    updateOptions() {
        let e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map(e => Array.from(e.querySelectorAll("input")).find(e => e.checked).value)
    }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        let e = (e, t) => {
            e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url).then(e => e.text()).then(e => {
                let t = document.createElement("div");
                t.innerHTML = e;
                let i = t.querySelector("product-recommendations");
                i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(), t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded")
            }).catch(e => {
                console.error(e)
            }))
        };
        new IntersectionObserver(e.bind(this), {
            rootMargin: "0px 0px 400px 0px"
        }).observe(this)
    }
}

function buildSearchQuery() {
    var e = document.querySelector("#custom-results");
    if (!e) return;
    e.addEventListener("submit", function(t) {
       var i = e.querySelector('[name="collection"]');
        if (!i || !i.selectedOptions || !i.selectedOptions.length) {
            return; // 🔥 prevents crash completely
}

    i.addEventListener("change", function(t) {
    if ("all" === i.selectedOptions[0].value) return null;
});

    var r = i.selectedOptions[0].value,
    s = i.selectedOptions[0].getAttribute("data-product-types")
        .trim()
        .replaceAll(/\s/g, "")
        .split("OR")
        .join(" OR ")
        .trim();
        if ("all" !== r) {
            t.preventDefault();
            var n = e.querySelector('[type="search"][name="q"]').value,
                a = "" === n;
            if (a) {
                var o = r.split("/")[2],
                    l = `/search?collection=${o}&type=product&q=${s}`;
                location.assign(l)
            }
            if (!a) {
                var o = r.split("/")[2],
                    l = `/search?collection=${o}&type=product&q=${n}`;
                location.assign(l)
            }
        }
    })
}

function filterCollection() {
    var e = location.href.includes("/search"),
        t = document.querySelector(".search-result-product .pagination-wrap");
    if (null !== t && (t.style.display = "none"), !e) return null;
    var rParams = new URLSearchParams(location.search),
        i = rParams.get("collection");
    if (!i || "all" === i) return null;
    var r = document.querySelector("#custom-results");
    r.querySelector('[type="search"][name="q"]').value.includes("OR") && (r.querySelector('[type="search"][name="q"]').value = i), document.querySelectorAll("[data-collection]").forEach(function(e) {
        e.style.display = "none", e.getAttribute("data-collection").includes(`"handle":"${i}"`) && (e.style.display = "block")
    }), document.querySelectorAll('[data-collection][style="display: block;"]').length >= 20 && null !== t && (t.style.display = "block")
}
customElements.define("product-recommendations", ProductRecommendations), buildSearchQuery(), filterCollection();